<template>
  <div id="lotto_info">
    <div class="eventInfo_status">
      <div class="attendance">
        <p>
          로또 참여자 <span>{{ joinListCnt }}</span>
        </p>
      </div>
      <div class="attendance_list" @click="goToAttendanceList">
        <p>참여자 목록</p>
      </div>
      <div class="attendance_list" @click="goToMyJoinList">
        <p>내 참여 목록</p>
      </div>
    </div>
      <div class="eventInfo_wrapper">
        <div class="talk_list">
          <!-- per talk -->
          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 내용</p>
                <p class="text" v-html="eventDesc.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 기간</p>
                <p class="text">
                  {{ openDate }} {{openTime}} ~  {{ endDate }} {{endTime}}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 경품</p>
                <p class="text">
                 
                  <span style="font:inherit ; font-weight:bold; color:#252D3A">1등 </span>  {{ winnerGift.replace("1등 ","") }}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 참여방법</p>
                <p class="text" v-html="eventHowto.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 발표</p>
                <p class="text">
                  {{ winnerOpenDate }} {{ winnerOpenTime}}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 조건</p>
                <p class="text" v-html="winnerCondition.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>
          <div class="talk_div" v-show="isIos">
            <div class="text_box">
              <div class="">
                <p class="text">* 해당 이벤트는 애플과 관련이 없습니다.</p>
              </div>
            </div>
          </div>
        </div>
    </div>  
  </div>
</template>

<script>
import { fetchInfomation, fetchAdCheck, requestCreate, fetchTicket, requestUse, fetchJoinList, fetchWinnerInfo } from '@/api/ngame'
export default {
  props: {
    joinListCnt: {
      type: Number
    },
    eventInfo: {
      type: Number
    },
    eventTitle: {
      type: String
    },
    eventDesc: {
      type: String
    },
    openDate: {
      type: String
    },
    openTime: {
      type: String
    },
    endDate: {
      type: String
    },
    endTime: {
      type: String
    },
    winnerGift: {
      type: String
    },
    eventHowto: {
      type: String
    },
    winnerOpenDate: {
      type: String
    },
    winnerOpenTime: {
      type: String
    },
    winnerCondition: {
      type: String
    }
  },
  data() {
    return {
      isIos: false
    }
  },
  created() {
    var varUA = navigator.userAgent.toLowerCase();
    if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        this.isIos = true;
    }
  },
  methods: {
    goToAttendanceList() {
      this.$router.push({
        path: '/lottoAttandanceList', query: {
          eventId: this.$route.query.eventId,
          eventTitle: this.$parent.eventTitle
        }
      })
    },
    goToMyJoinList() {
      this.$router.push({
        path: '/lottoMyJoinList', query: {
          eventId: this.$route.query.eventId,
          eventTitle: this.$route.query.eventId+"회차 내 참여"
        }
      })
    },
  },
}
</script>

<style scoped>

</style>